export const LOOKUPS = {
  ACTIVE: 'Active',
  UNDER_MAINTENANCE: 'UNDER_MAINTENANCE',
  INACTIVE: 'Inactive',
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
  ACTION: 'Action',
  LOCKED: 'Locked',
  UNLOCK: 'Unlock',
  DEPARTMENT: 'DEPARTMENT',
  RECON_MID_SETTING_TYPE: 'RECON_MID_SETTING_TYPE',
  USER_ACCESS: 'USER_ACCESS',
  FARMING_LEAD: 'Farming Lead',
  HUNTING_LEAD: 'Hunting Lead',
  REMOVE: 'Remove',
  DONE: 'Done',
  PENDING: 'Pending',
  FAILED: 'Failed',
  SUCCESS: 'Success',
  CALL_APPOINTMENT: 'Call Appointment',
  ONSITE_MEETING_APPOINTMENT: 'Onsite Meeting Appointment',
  VIRTUAL_MEETING_APPOINTMENT: 'Virtual Meeting Appointment',
  AVAILABLE_FOR_APPOINTMENT: 'Available for Appointment',
  LIST: 'LIST',
  CALENDAR: 'CALENDAR',
  REPORT: 'REPORT',
  TEAM: 'TEAM',
  MERCHANT_CLASSIFICATION: 'MERCHANT_CLASSIFICATION',
  LIST_DATA_OPTION: 'LIST_DATA_OPTION',
  APPOINTMENT_TYPE: 'APPOINTMENT_TYPE',
  APPOINTMENT_STATUS: 'APPOINTMENT_STATUS',
  CALENDAR_STATUS: 'CALENDAR_STATUS',
  VIEW_TYPE: 'VIEW_TYPE',
  OUTLET_TYPE: 'OUTLET_TYPE',
  LEAD_LIST_TYPE: 'LEAD_LIST_TYPE',
  LEAD_CONTACT_INFO_TYPE: 'LEAD_CONTACT_INFO_TYPE',
  SERVICE_TYPE: 'SERVICE_TYPE',
  MERCHANT_GROUP: 'MERCHANT_GROUP',
  MERCHANT_SERVICES: 'MERCHANT_SERVICES',
  CURRENCY: 'CURRENCY',
  SETUP_FEE_STATUS: 'SETUP_FEE_STATUS',
  CONTACT_INFO_TYPE: 'CONTACT_INFO_TYPE',
  UNIT_MEASUREMENT: 'UNIT_MEASUREMENT',
  SALE_CATEGORY: 'SALE_CATEGORY',
  DATE_TYPE: 'DATE_TYPE',
  REPORT_TYPE: 'REPORT_TYPE',
  ADMINISTRATOR: 'ADMINISTRATOR',
  STATUS: 'STATUS',
  USER_TYPE: 'USER_TYPE',
  TEST_CREDENTIALS_ISSUED: 'Test Credentials Issued',
  SIGNED_CONTRACT: 'Signed Contract',
  PRODUCTION_RELEASED: 'Production Released',
  CLIENT_MEETING: 'Client Meeting',
  PROPOSAL: 'Proposal',
  BILLED_SETUP_FEE: 'Billed Setup Fee',
  PAID_SETUP_FEE: 'Paid Setup Fee',
  DASHBOARD_FRAUD_TRAINING: 'Dashboard and Fraud Training',
  COMPLETION_OF_DOCUMENTS: 'Completion of Documents',
  LEADS_GENERATION: 'Leads Generation',
  MARK_AS_DONE: 'Mark as Done',
  MARK_AS_FAILED: 'Mark as Failed',
  RESCHEDULE: 'Reschedule',
  CANCEL: 'Cancel',
  BASIC_INFORMATION: 'Basic Information',
  OWNER_INFORMATION: 'Owner Information',
  CONTACT_INFORMATION: 'Contact Information',
  SERVICE_INFORMATION: 'Service Information',
  SYSTEM_INFORMATION: 'System Information',
  TRANSACTION_COUNT: 'Transaction Count',
  TRANSACTION_VOLUME: 'Transaction Volume',
  ADDRESS: 'Address',
  PROVINCE: 'Province',
  PAYGATE: 'Paygate',
  PAYBIZ: 'Paybiz',
  RISK_PROFILE: 'RISK_PROFILE',
  ACCOUNT_OFFICER: 'Account Officer',
  USER: 'User',
  FILE_STATUS: 'FILE_STATUS',
  SENT_BY_PAYNAMICS: 'SENT BY PAYNAMICS',
  SENT_BY_MERCHANT: 'SENT BY MERCHANT',
  ROLES: 'ROLES',
  EXTERNAL_RECIPIENTS: 'EXTERNAL_RECIPIENTS',
  STATUS_CHANGE_REQUIREMENT: 'STATUS_CHANGE_REQUIREMENT',
  BY_UPLOAD: 'By Upload',
  BY_REMARKS: 'By Remarks',
  PRE: 'PRE',
  POST: 'POST',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  INCOMPLETE: 'Incomplete',
  REQUIREMENT_VALIDATION: 'REQUIREMENT_VALIDATION',
  MERCHANT_PROFILE: 'MERCHANT_PROFILE',
  MERCHANT_CONFIGURATION: 'MERCHANT_CONFIGURATION',
  MERCHANT_MANAGEMENT: 'MERCHANT_MANAGEMENT',
  AMOUNT_LEVEL: 'Amount Level',
  MERCHANT_SETTINGS: 'Merchant Settings',
  HIGH: 'High',
  DISCUSSION_TYPE: 'DISCUSSION_TYPE',
  SYSTEM: 'SYSTEM',
  ATTACHMENT: 'ATTACHMENT',
  CHAT: 'CHAT',
  PRIORITY: 'PRIORITY',
  HIGHEST: 'Highest',
  LOW: 'Low',
  LOWEST: 'Lowest',
  CASE_STATUS: 'CASE_STATUS',
  IN_PROGRESS: 'In Progress',
  FOR_REVIEW: 'For Review',
  TO_DO: 'To Do',
  DESCRIPTION: 'DESCRIPTION',
  ASSIGNEE: 'ASSIGNEE',
  DATA_TYPE: 'DATA_TYPE',
  SERVICE_SETTINGS_TYPE: 'SERVICE_SETTINGS_TYPE',
  TRANSACTION_TYPE: 'TRANSACTION_TYPE',
  VOID: 'Void',
  PAID: 'Paid',
  BILLING_STATUS: 'BILLING_STATUS',
  MATCH_RECORD: 'MATCH_RECORD',
  DISCREPANCY_AT_CLIENT_RECORD: 'DISCREPANCY_AT_CLIENT_RECORD',
  DISCREPANCY_AT_COMPANY_RECORD: 'DISCREPANCY_AT_COMPANY_RECORD',
  RECORD_TYPE: 'RECORD_TYPE',
  UNRECONCILED: 'Unreconciled',
  MATCHED: 'Matched',
  RECONCILED: 'Reconciled',
  RECORD_STATUS: 'RECORD_STATUS',
  MATCHED_FROM_DEV_SERVER: 'MATCHED_FROM_DEV_SERVER',
  MATCHED_FROM_PAYGATE_DATABASE: 'MATCHED_FROM_PAYGATE_DATABASE',
  TEMPLATE_DATA_TYPE: 'TEMPLATE_DATA_TYPE',
  TEMPLATE_FIELD_TYPE: 'TEMPLATE_FIELD_TYPE',
  DATE_FORMAT: 'DATE_FORMAT',
  SESSION_EXPIRY: 'SESSION_EXPIRY',
  OTP_ACTIONS: 'OTP_ACTIONS',
  OTP_PURPOSE: 'OTP_PURPOSE',
  NUMBER_OF_EMPLOYEES: 'NUMBER_OF_EMPLOYEES',
  TAX_EXEMPTION: 'TAX_EXEMPTION',
  TRANSACTION_COUNT_PER_MONTH: 'TRANSACTION_COUNT_PER_MONTH',
  POTENTIAL_VOLUME_PER_MONTH: 'POTENTIAL_VOLUME_PER_MONTH',
  COMPANY_INFORMATION: 'Company Information',
  OTHER_COMPANY_INFORMATION: 'Other Company Information',
  AUTHORIZED_SIGNATORY: 'Authorized Signatory',
  SETTLEMENT_INFORMATION: 'Settlement Information',
  PRIMARY_CONTACT: 'Primary Contact',
  MERCHANT_STATUS: 'MERCHANT_STATUS',
  ACTIVITY: 'Activity',
  LEAD_LOG_STATUS_UPDATE_ACTIONS: 'LEAD_LOG_STATUS_UPDATE_ACTIONS',
  SETTLEMENT_CYCLE: 'SETTLEMENT_CYCLE',
  PF_OR_DIRECT: 'PF_OR_DIRECT',
  NOTIFICATION_TYPE: 'NOTIFICATION_TYPE',
  KYB_STATUS: 'KYB_DOCUMENT_STATUS',
  KYB_TYPE: 'KYB_DOCUMENT_TYPE',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'Rejected',
  BUSINESS_SIZE: 'BUSINESS_SIZE',
  MONTHLY_RENTAL: 'MONTHLY_RENTAL',
  REFERRED_BY: 'REFERRED_BY',
  BILLING_METHOD: 'BILLING_METHOD',
  OWNERSHIP: 'OWNERSHIP',
  REVIEWED: 'Reviewed',
  GENERATED: 'Generated',
  ENDORSED: 'Endorsed',
  GENERATING: 'Generating',
  RISK_LEVEL: 'RISK_LEVEL',
  LOW_RISK: 'Low Risk',
  HIGH_RISK: 'High Risk',
  APPROVED_BY_SALES_HEAD: 'Approved by Sales Head',
  APPROVED_BY_FINANCE_HEAD: 'Approved by Finance Head',
  PAYNAMICS_SERVICE: 'PAYNAMICS_SERVICE',
  BILLING_ADDITIONAL_FEE_FREQUENCY: 'BILLING_ADDITIONAL_FEE_FREQUENCY',
  TAGGED_AS_FLOATING_TRANSACTION: 'TAGGED_AS_FLOATING_TRANSACTION',
  MERCHANT_TYPE: 'MERCHANT_TYPE',
  MERCHANT_MIGRATION_STATUS: 'MERCHANT_MIGRATION_STATUS',
  MERCHANT_IDS: 'MERCHANT_IDS',
  MERCHANT_APPLICATION_STATUS: 'MERCHANT_APPLICATION_STATUS',
  REJECT_WITH_REMEDIATION: 'Reject with Remediation',
  REJECT_TOTALLY: 'Reject Totally',
  MERCHANT_PROFILE_LOGS: 'MERCHANT_PROFILE_LOGS',
  MERCHANT_CERTIFICATE: 'MERCHANT_CERTIFICATE',
  KYB_DOCUMENT_TYPE: 'KYB_DOCUMENT_TYPE',
  TAGGED_AS_REFUND: 'TAGGED_AS_REFUND',
  TAGGED_AS_AUTO_REVERSAL: 'TAGGED_AS_AUTO_REVERSAL',
  TAGGED_AS_OFFSET: 'TAGGED_AS_OFFSET',
  TAG_AS_MANUAL_RECON: 'TAG_AS_MANUAL_RECON',
  TAG_AS_REVIEW: 'TAG_AS_REVIEW',
  TAG_AS_ENDORSED: 'TAG_AS_ENDORSED',
  WITH_TAX: 'With Tax',
  TAX_EXEMPT: 'Tax Exempt',
  PESO: 'Peso',
  US_DOLLAR: 'US Dollar',
  MANUAL_SETTLEMENT: 'MANUAL_SETTLEMENT'
};

export const PAGEACTION = {
  EDIT_ACCOUNT_OFFICERS: 'EDIT_ACCOUNT_OFFICERS',
  DELETE_ACCOUNT_OFFICERS: 'DELETE_ACCOUNT_OFFICERS',
  ADD_ACCOUNT_OFFICERS: 'ADD_ACCOUNT_OFFICERS',
  VIEW_ALL_LEADS_MANAGEMENT: 'VIEW_ALL_LEADS_MANAGEMENT',
  VIEW_OWN_LEADS_MANAGEMENT: 'VIEW_OWN_LEADS_MANAGEMENT',
  ADD_LEADS_MANAGEMENT: 'ADD_LEADS_MANAGEMENT',
  ADD_LEADS_BY_RELATIONSHIP_MANAGER: 'ADD_LEADS_BY_RELATIONSHIP_MANAGER',
  EDIT_TARGET_PROJECTIONS: 'EDIT_TARGET_PROJECTIONS',
  ADD_TARGET_PROJECTIONS: 'ADD_TARGET_PROJECTIONS',
  EDIT_MERCHANT_PROFILE: 'EDIT_MERCHANT_PROFILE',
  ADD_MERCHANT_PROFILE: 'ADD_MERCHANT_PROFILE',
  VIEW_ALL_MERCHANT_PROFILE: 'VIEW_ALL_MERCHANT_PROFILE',
  ADD_REPORT_TYPE: 'ADD_REPORT_TYPE',
  VIEW_ALL_REPORT_TYPE: 'VIEW_ALL_REPORT_TYPE',
  ADD_ADDRESS: 'ADD_ADDRESS',
  SET_KEY_ADDRESS: 'SET_KEY_ADDRESS',
  EDIT_ADDRESS: 'EDIT_ADDRESS',
  DELETE_ADDRESS: 'DELETE_ADDRESS',
  ADD_INDUSTRIES: 'ADD_INDUSTRIES',
  EDIT_INDUSTRIES: 'EDIT_INDUSTRIES',
  DELETE_INDUSTRIES: 'DELETE_INDUSTRIES',
  VIEW_LOOKUPS: 'VIEW_LOOKUPS',
  ADD_LOOKUPS: 'ADD_LOOKUPS',
  EDIT_LOOKUPS: 'EDIT_LOOKUPS',
  DELETE_LOOKUPS: 'DELETE_LOOKUPS',
  EDIT_LOOKUP_GROUP: 'EDIT_LOOKUP_GROUP',
  DELETE_LOOKUP_GROUP: 'DELETE_LOOKUP_GROUP',
  ADD_LOOKUP_GROUP: 'ADD_LOOKUP_GROUP',
  EDIT_ROLE_MANAGEMENT: 'EDIT_ROLE_MANAGEMENT',
  ADD_ROLE_MANAGEMENT: 'ADD_ROLE_MANAGEMENT',
  DELETE_ROLE_MANAGEMENT: 'DELETE_ROLE_MANAGEMENT',
  EDIT_USER_MANAGEMENT: 'EDIT_USER_MANAGEMENT',
  ADD_USER_MANAGEMENT: 'ADD_USER_MANAGEMENT',
  UNLOCK_USER: 'UNLOCK_USER',
  UNLOCK_USER_ACCOUNT: 'UNLOCK_USER_ACCOUNT',
  DELETE_USER_MANAGEMENT: 'DELETE_USER_MANAGEMENT',
  VIEW_BY_DEPARTMENT_USER_MANAGEMENT: 'VIEW_BY_DEPARTMENT_USER_MANAGEMENT',
  INVITE_USER_MANAGEMENT: 'INVITE_USER_MANAGEMENT',
  VIEW_ALL_INVITED_USER_MANAGEMENT: 'VIEW_ALL_INVITED_USER_MANAGEMENT',
  EDIT_LEADS_MANAGEMENT: 'EDIT_LEADS_MANAGEMENT',
  ADD_MODULE: 'ADD_MODULE',
  VIEW_ALL_MODULE: 'VIEW_ALL_MODULE',
  EDIT_MODULE: 'EDIT_MODULE',
  DELETE_MODULE: 'DELETE_MODULE',
  VIEW_ALL_MERCHANT_PAYMENT_CHANNEL: 'VIEW_ALL_MERCHANT_PAYMENT_CHANNEL',
  ADD_MERCHANT_PAYMENT_CHANNEL: 'ADD_MERCHANT_PAYMENT_CHANNEL',
  EDIT_MERCHANT_PAYMENT_CHANNEL: 'EDIT_MERCHANT_PAYMENT_CHANNEL',
  DELETE_MERCHANT_PAYMENT_CHANNEL: 'DELETE_MERCHANT_PAYMENT_CHANNEL',
  VIEW_ALL_MERCHANT_LOGS: 'VIEW_ALL_MERCHANT_LOGS',
  ADD_MERCHANT_LOGS: 'ADD_MERCHANT_LOGS',
  EDIT_MERCHANT_LOGS: 'EDIT_MERCHANT_LOGS',
  DELETE_MERCHANT_LOGS: 'DELETE_MERCHANT_LOGS',
  VIEW_ALL_PAYMENT_CHANNEL: 'VIEW_ALL_PAYMENT_CHANNEL',
  ADD_PAYMENT_CHANNEL: 'ADD_PAYMENT_CHANNEL',
  EDIT_PAYMENT_CHANNEL: 'EDIT_PAYMENT_CHANNEL',
  DELETE_PAYMENT_CHANNEL: 'DELETE_PAYMENT_CHANNEL',
  VIEW_ALL_NOTIFICATION_SETTINGS: 'VIEW_ALL_NOTIFICATION_SETTINGS',
  ADD_NOTIFICATION_SETTINGS: 'ADD_NOTIFICATION_SETTINGS',
  EDIT_NOTIFICATION_SETTINGS: 'EDIT_NOTIFICATION_SETTINGS',
  DELETE_NOTIFICATION_SETTINGS: 'DELETE_NOTIFICATION_SETTINGS',
  VIEW_FILE_MANAGEMENT: 'VIEW_FILE_MANAGEMENT',
  UPLOAD_FILE_MANAGEMENT: 'UPLOAD_FILE_MANAGEMENT',
  UPLOAD_FILE_MANAGEMENT_KYB_FILE: 'UPLOAD_FILE_MANAGEMENT_KYB_FILE',
  DOWNLOAD_FILE_MANAGEMENT: 'DOWNLOAD_FILE_MANAGEMENT',
  DELETE_FILE_MANAGEMENT: 'DELETE_FILE_MANAGEMENT',
  VIEW_MERCHANT_SETTINGS: 'VIEW_MERCHANT_SETTINGS',
  ADD_MERCHANT_SETTINGS: 'ADD_MERCHANT_SETTINGS',
  EDIT_MERCHANT_SETTINGS: 'EDIT_MERCHANT_SETTINGS',
  DELETE_MERCHANT_SETTINGS: 'DELETE_MERCHANT_SETTINGS',
  VIEW_RECONCILIATION: 'VIEW_RECONCILIATION',
  ADD_RECONCILIATION: 'ADD_RECONCILIATION',
  EDIT_RECONCILIATION: 'EDIT_RECONCILIATION',
  ENDORSE_GENERATED_RECONCILIATION_REPORT: 'ENDORSE_GENERATED_RECONCILIATION_REPORT',
  APPROVE_GENERATED_RECONCILIATION_REPORT: 'APPROVE_GENERATED_RECONCILIATION_REPORT',
  REJECT_GENERATED_RECONCILIATION_REPORT: 'REJECT_GENERATED_RECONCILIATION_REPORT',
  ESCALATE_CASE: 'ESCALATE_CASE',
  DELETE_RECONCILIATION: 'DELETE_RECONCILIATION',
  VIEW_MONTHLY_RECONCILED_REPORTS: 'VIEW_MONTHLY_RECONCILED_REPORTS',
  GENERATE_MONTHLY_REPORT: 'GENERATE_MONTHLY_REPORT',
  DOWNLOAD_MONTHLY_RECONCILED_REPORT: 'DOWNLOAD_MONTHLY_RECONCILED_REPORT',
  VIEW_RECONCILIATION_VERSION_TWO: 'VIEW_RECONCILIATION_VERSION_TWO',
  ADD_RECONCILIATION_VERSION_TWO: 'ADD_RECONCILIATION_VERSION_TWO',
  EDIT_RECONCILIATION_VERSION_TWO: 'EDIT_RECONCILIATION_VERSION_TWO',
  DELETE_RECONCILIATION_VERSION_TWO: 'DELETE_RECONCILIATION_VERSION_TWO',
  FIND_TRANSACTION: 'FIND_TRANSACTION',
  UPLOAD_TRANSACTION: 'UPLOAD_TRANSACTION',
  AMEND_TRANSACTION: 'AMEND_TRANSACTION',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  VIEW_BILLING: 'VIEW_BILLING',
  ADD_BILLING: 'ADD_BILLING',
  EDIT_BILLING: 'EDIT_BILLING',
  DELETE_BILLING: 'DELETE_BILLING',
  DOWNLOAD_BILLING: 'DOWNLOAD_BILLING',
  VIEW_ALL_UPLOAD_TRANSACTION: 'VIEW_ALL_UPLOAD_TRANSACTION',
  ADD_UPLOAD_TRANSACTION: 'ADD_UPLOAD_TRANSACTION',
  GENERATE_UPLOAD_TRANSACTION: 'GENERATE_UPLOAD_TRANSACTION',
  EDIT_UPLOAD_TRANSACTION: 'EDIT_UPLOAD_TRANSACTION',
  DELETE_UPLOAD_TRANSACTION: 'DELETE_UPLOAD_TRANSACTION',
  DELETE_CASE: 'DELETE_CASE',
  COMMENT_CASE: 'COMMENT_CASE',
  DOWNLOAD_CASE: 'DOWNLOAD_CASE',
  EDIT_CASE: 'EDIT_CASE',
  ADD_CASE: 'ADD_CASE',
  VIEW_CASE: 'VIEW_CASE',
  VIEW_FINANCE_DASHBOARD: 'VIEW_FINANCE_DASHBOARD',
  ADD_FINANCE_DASHBOARD: 'ADD_FINANCE_DASHBOARD',
  EDIT_FINANCE_DASHBOARD: 'EDIT_FINANCE_DASHBOARD',
  DOWNLOAD_FINANCE_DASHBOARD: 'DOWNLOAD_FINANCE_DASHBOARD',
  DELETE_FINANCE_DASHBOARD: 'DELETE_FINANCE_DASHBOARD',
  VIEW_SYSTEM_SETTINGS: 'VIEW_SYSTEM_SETTINGS',
  CREATE_SYSTEM_SETTINGS: 'CREATE_SYSTEM_SETTINGS',
  EDIT_SYSTEM_SETTINGS: 'EDIT_SYSTEM_SETTINGS',
  DELETE_SYSTEM_SETTINGS: 'DELETE_SYSTEM_SETTINGS',
  VIEW_FINANCE_BANK: 'VIEW_FINANCE_BANK',
  ADD_FINANCE_BANK: 'ADD_FINANCE_BANK',
  EDIT_FINANCE_BANK: 'EDIT_FINANCE_BANK',
  UPLOAD_FINANCE_BANK: 'UPLOAD_FINANCE_BANK',
  DOWNLOAD_FINANCE_BANK: 'DOWNLOAD_FINANCE_BANK',
  DELETE_FINANCE_BANK: 'DELETE_FINANCE_BANK',
  ADD_PAGE_ACTION: 'ADD_PAGE_ACTION',
  VIEW_CONFIDENTIAL_BANK_INFO: 'VIEW_CONFIDENTIAL_BANK_INFO',
  VIEW_REMITTING_CHANNEL_SCHEDULE: 'VIEW_REMITTING_CHANNEL_SCHEDULE',
  ADD_REMITTING_CHANNEL_SCHEDULE: 'ADD_REMITTING_CHANNEL_SCHEDULE',
  EDIT_REMITTING_CHANNEL_SCHEDULE: 'EDIT_REMITTING_CHANNEL_SCHEDULE',
  ADD_OTP_MANAGEMENT: 'ADD_OTP_MANAGEMENT',
  EDIT_OTP_MANAGEMENT: 'EDIT_OTP_MANAGEMENT',
  DELETE_OTP_MANAGEMENT: 'DELETE_OTP_MANAGEMENT',
  GENERATE_SECRET_KEY: 'GENERATE_SECRET_KEY',
  VIEW_ALL_OTP_MANAGEMENT: 'VIEW_ALL_OTP_MANAGEMENT',
  FILTER_OTP_LOGS: 'FILTER_OTP_LOGS',
  VIEW_DOCUMENTATION_OTP_MANAGEMENT: 'VIEW_DOCUMENTATION_OTP_MANAGEMENT',
  VIEW_LOG_REQUEST_BODY_OTP_MANAGEMENT: 'VIEW_LOG_REQUEST_BODY_OTP_MANAGEMENT',
  TEST_REQUIREMENTS_OTP_MANAGEMENT: 'TEST_REQUIREMENTS_OTP_MANAGEMENT',
  VIEW_FINANCE_OTC_RECON: 'VIEW_FINANCE_OTC_RECON',
  ADD_FINANCE_OTC_RECON: 'ADD_FINANCE_OTC_RECON',
  EDIT_FINANCE_OTC_RECON: 'EDIT_FINANCE_OTC_RECON',
  DELETE_FINANCE_OTC_RECON: 'DELETE_FINANCE_OTC_RECON',
  FILTER_TRANSACTIONS: 'FILTER_TRANSACTIONS',
  FILTER_MERCHANT_STATUS_COUNT: 'FILTER_MERCHANT_STATUS_COUNT',
  DOWNLOAD_TRANSACTIONS: 'DOWNLOAD_TRANSACTIONS',
  VIEW_TRANSACTIONS: 'VIEW_TRANSACTIONS',
  VIEW_TRANSACTIONS_DETAILS: 'VIEW_TRANSACTIONS_DETAILS',
  VIEW_MERCHANT_DEFINED_PARAMETERS: 'VIEW_MERCHANT_DEFINED_PARAMETERS',
  VIEW_OTHER_INFORMATION: 'VIEW_OTHER_INFORMATION',
  VIEW_CARD_DETAILS: 'VIEW_CARD_DETAILS',
  VIEW_ORDER_DETAILS: 'VIEW_ORDER_DETAILS',
  VIEW_WORKFLOW: 'VIEW_WORKFLOW',
  VIEW_TOKENIZATION: 'VIEW_TOKENIZATION',
  VIEW_RECONCILIATION_DETAILS: 'VIEW_RECONCILIATION_DETAILS',
  VIEW_REMITTANCE_DETAILS: 'VIEW_REMITTANCE_DETAILS',
  VIEW_SETTLEMENT_INFO: 'VIEW_SETTLEMENT_INFO',
  VIEW_FINAL_NOTIFICATIONS: 'VIEW_FINAL_NOTIFICATIONS',
  VIEW_DETAILS: 'VIEW_DETAILS',
  CREATE_RESPONSE_CODES: 'CREATE_RESPONSE_CODES',
  EDIT_RESPONSE_CODES: 'EDIT_RESPONSE_CODES',
  CHANGE_STATUS_RESPONSE_CODES: 'CHANGE_STATUS_RESPONSE_CODES',
  CREATE_SECURITY_CODES: 'CREATE_SECURITY_CODES',
  EDIT_SECURITY_CODES: 'EDIT_SECURITY_CODES',
  CHANGE_STATUS_SECURITY_CODES: 'CHANGE_STATUS_SECURITY_CODES',
  VIEW_MERCHANT_INFORMATION: 'VIEW_MERCHANT_INFORMATION',
  CREATE_MERCHANT_INFORMATION: 'CREATE_MERCHANT_INFORMATION',
  UPDATE_MERCHANT_INFORMATION: 'UPDATE_MERCHANT_INFORMATION',
  MANUAL_RECONCILE_TRX: 'MANUAL_RECONCILE_TRX',
  ALERT_LTWO_ACTION: 'ALERT_LTWO_ACTION',
  CREATE_MERCHANT_STATUS: 'CREATE_MERCHANT_STATUS',
  EDIT_MERCHANT_STATUS: 'EDIT_MERCHANT_STATUS',
  CHANGE_STATUS_MERCHANT_STATUS: 'CHANGE_STATUS_MERCHANT_STATUS',
  REORDER_MERCHANT_STATUS: 'REORDER_MERCHANT_STATUS',
  FILTER_LEAD_MONITORING: 'FILTER_LEAD_MONITORING',
  EDIT_LEAD_ACCOUNT_OFFICER: 'EDIT_LEAD_ACCOUNT_OFFICER',
  FILTER_LEADS_NURTURING: 'FILTER_LEADS_NURTURING',
  COMMENT_LEADS_NURTURING: 'COMMENT_LEADS_NURTURING',
  START_LEAD_NURTURING: 'START_LEAD_NURTURING',
  CREATE_LEAD_NURTURING_APPOINTMENT: 'CREATE_LEAD_NURTURING_APPOINTMENT',
  EDIT_LEADS_NURTURING_APPOINTMENT: 'EDIT_LEADS_NURTURING_APPOINTMENT',
  VIEW_LEAD_ACTIVITY_DETAILS: 'VIEW_LEAD_ACTIVITY_DETAILS',
  SEARCH_ACCOUNT_OFFICERS: 'SEARCH_ACCOUNT_OFFICERS',
  FILTER_ACCOUNT_OFFICERS: 'FILTER_ACCOUNT_OFFICERS',
  VIEW_OWN_TEAM_ACCOUNT_OFFICERS: 'VIEW_OWN_TEAM_ACCOUNT_OFFICERS',
  VIEW_ALL_TEAM_ACCOUNT_OFFICERS: 'VIEW_ALL_TEAM_ACCOUNT_OFFICERS',
  VIEW_TEAM_ACCOUNT_OFFICERS: 'VIEW_TEAM_ACCOUNT_OFFICERS',
  CREATE_TEAM_ACCOUNT_OFFICERS: 'CREATE_TEAM_ACCOUNT_OFFICERS',
  EDIT_TEAM_ACCOUNT_OFFICERS: 'EDIT_TEAM_ACCOUNT_OFFICERS',
  FILTER_USER_ACTIVITY_ACCOUNT_OFFICERS: 'FILTER_USER_ACTIVITY_ACCOUNT_OFFICERS',
  VIEW_LOG_REQUEST_BODY_LEAD_NURTURING: 'VIEW_LOG_REQUEST_BODY_LEAD_NURTURING',
  VIEW_LOG_REQUEST_BODY_LEADS_MANAGEMENT: 'VIEW_LOG_REQUEST_BODY_LEADS_MANAGEMENT',
  EDIT_LEADS_SANITATION: 'EDIT_LEADS_SANITATION',
  EDIT_LEADS_RELATIONS_MANAGER: 'EDIT_LEADS_RELATIONS_MANAGER',
  VALIDATE_LEADS_SANITATION: 'VALIDATE_LEADS_SANITATION',
  VALIDATE_LEAD_SANITATION_LEADS_MANAGEMENT: 'VALIDATE_LEAD_SANITATION_LEADS_MANAGEMENT',
  ASSIGN_LEAD_ONCE: 'ASSIGN_LEAD_ONCE',
  VIEW_MERCHANT_MANAGEMENT_LOGS: 'VIEW_MERCHANT_MANAGEMENT_LOGS',
  VIEW_MERCHANT_MANAGEMENT_NOTES: 'VIEW_MERCHANT_MANAGEMENT_NOTES',
  ADD_MERCHANT_MANAGEMENT_NOTES: 'ADD_MERCHANT_MANAGEMENT_NOTES',
  EDIT_MERCHANT_MANAGEMENT_NOTES: 'EDIT_MERCHANT_MANAGEMENT_NOTES',
  VIEW_MERCHANT_MANAGEMENT_SALES_REQUIRED_INFORMATION:
    'VIEW_MERCHANT_MANAGEMENT_SALES_REQUIRED_INFORMATION',
  COMPLETE_REQUIREMENTS_MERCHANT_MANAGEMENT: 'COMPLETE_REQUIREMENTS_MERCHANT_MANAGEMENT',
  DOWNLOAD_FILE_MERCHANT_MANAGEMENT: 'DOWNLOAD_FILE_MERCHANT_MANAGEMENT',
  TRIGGER_CREATION_OF_INVOICE: 'TRIGGER_CREATION_OF_INVOICE',
  VIEW_LOGS_REQUEST_BODY_MERCHANT_MANAGEMENT: 'VIEW_LOGS_REQUEST_BODY_MERCHANT_MANAGEMENT',
  VIEW_VAT_EXEMPTION_FINANCE_OPERATIONS: 'VIEW_VAT_EXEMPTION_FINANCE_OPERATIONS',
  VIEW_INVOICE_FINANCE_OPERATIONS: 'VIEW_INVOICE_FINANCE_OPERATIONS',
  VIEW_LOG_FINANCE_OPERATIONS: 'VIEW_LOG_FINANCE_OPERATIONS',
  VIEW_LOG_REQUEST_BODY_FINANCE_OPERATIONS: 'VIEW_LOG_REQUEST_BODY_FINANCE_OPERATIONS',
  VIEW_PROOF_OF_PAYMENT: 'VIEW_PROOF_OF_PAYMENT',
  VIEW_PROOF_OF_PAYMENT_FILE: 'VIEW_PROOF_OF_PAYMENT_FILE',
  VIEW_LOG_EMAIL_NOTIFICATION_RECIPIENTS: 'VIEW_LOG_EMAIL_NOTIFICATION_RECIPIENTS',
  DOWNLOAD_PROOF_OF_PAYMENT: 'DOWNLOAD_PROOF_OF_PAYMENT',
  MANAGE_PROOF_OF_PAYMENT: 'MANAGE_PROOF_OF_PAYMENT',
  CONFIRM_PROOF_OF_PAYMENT: 'CONFIRM_PROOF_OF_PAYMENT',
  DOWNLOAD_FILE_FINANCE_OPERATIONS: 'DOWNLOAD_FILE_FINANCE_OPERATIONS',
  VALIDATE_VAT_EXEMPTION_FINANCE_OPERATIONS: 'VALIDATE_VAT_EXEMPTION_FINANCE_OPERATIONS',
  REQUEST_VAT_EXEMPTION_APPROVAL: 'REQUEST_VAT_EXEMPTION_APPROVAL',
  VIEW_CONFIDENTIAL_BANK_DETAILS: 'VIEW_CONFIDENTIAL_BANK_DETAILS',
  CREATE_INVOICE_FINANCE_OPERATIONS: 'CREATE_INVOICE_FINANCE_OPERATIONS',
  REQUEST_INVOICE_APPROVAL: 'REQUEST_INVOICE_APPROVAL',
  REQUEST_VAT_RECLASSIFICATION: 'REQUEST_VAT_RECLASSIFICATION',
  APPROVE_VAT_RECLASSIFICATION_REQUEST: 'APPROVE_VAT_RECLASSIFICATION_REQUEST',
  REJECT_VAT_RECLASSIFICATION_REQUEST: 'REJECT_VAT_RECLASSIFICATION_REQUEST',
  REVIEW_VAT_RECLASSIFICATION_REQUEST: 'REVIEW_VAT_RECLASSIFICATION_REQUEST',
  REQUEST_VAT_RECLASSIFY: 'REQUEST_VAT_RECLASSIFY',
  REVIEW_VAT_RECLASSIFY_REQUEST: 'REVIEW_VAT_RECLASSIFY_REQUEST',
  VALIDATE_INVOICE_FINANCE_OPERATIONS: 'VALIDATE_INVOICE_FINANCE_OPERATIONS',
  VIEW_TEMPLATE_LEAD: 'VIEW_TEMPLATE_LEAD',
  ADD_TEMPLATE_LEAD: 'ADD_TEMPLATE_LEAD',
  EDIT_TEMPLATE_LEAD: 'EDIT_TEMPLATE_LEAD',
  UPLOAD_LEAD_FILE: 'UPLOAD_LEAD_FILE',
  VIEW_ALL_UPLOADED_LEAD_FILE: 'VIEW_ALL_UPLOADED_LEAD_FILE',
  VIEW_SUSPECTED_DUPLICATE_LEAD: 'VIEW_SUSPECTED_DUPLICATE_LEAD',
  VIEW_ALL_DEPARTMENT_USER_MANAGEMENT: 'VIEW_ALL_DEPARTMENT_USER_MANAGEMENT',
  SEND_MERCHANT_INVOICE: 'SEND_MERCHANT_INVOICE',
  ACCEPT_SUSPECTED_DUPLICATE_LEAD: 'ACCEPT_SUSPECTED_DUPLICATE_LEAD',
  REJECT_SUSPECTED_DUPLICATE_LEAD: 'REJECT_SUSPECTED_DUPLICATE_LEAD',
  REUPLOAD_LEAD_FILE: 'REUPLOAD_LEAD_FILE',
  EDIT_KYB_MERCHANT_DOCUMENT: 'EDIT_KYB_MERCHANT_DOCUMENT',
  DOWNLOAD_KYB_MERCHANT_DOCUMENT: 'DOWNLOAD_KYB_MERCHANT_DOCUMENT',
  VIEW_KYB_MERCHANT_PORTAL: 'VIEW_KYB_MERCHANT_PORTAL',
  VIEW_MERCHANT_PORTAL_LOGS: 'VIEW_MERCHANT_PORTAL_LOGS',
  SEND_MIS_FORM_LINK: 'SEND_MIS_FORM_LINK',
  VIEW_MENU_MERCHANT_PORTAL: 'VIEW_MENU_MERCHANT_PORTAL',
  VIEW_ALL_GENERATED_KYB_FORM_LINKS: 'VIEW_ALL_GENERATED_KYB_FORM_LINKS',
  VIEW_MERCHANT_PORTAL_ACCOUNT_HISTORY: 'VIEW_MERCHANT_PORTAL_ACCOUNT_HISTORY',
  ASSIGN_MERCHANT_ONBOARDING: 'ASSIGN_MERCHANT_ONBOARDING',
  AMEND_MERCHANT_INFORMATION_SHEET: 'AMEND_MERCHANT_INFORMATION_SHEET',
  ENDORSE_MIS_AMENDMENT: 'ENDORSE_MIS_AMENDMENT',
  APPROVE_MIS_AMENDMENT: 'APPROVE_MIS_AMENDMENT',
  GENERATE_KYB_FORM_LINK: 'GENERATE_KYB_FORM_LINK',
  RESEND_KYB_FORM_LINK: 'RESEND_KYB_FORM_LINK',
  UPDATE_RISK_LEVEL: 'UPDATE_RISK_LEVEL',
  GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_RECONCILIATION:
    'GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_RECONCILIATION',
  VIEW_OPTIONS_RECONCILIATION: 'VIEW_OPTIONS_RECONCILIATION',
  VIEW_FINANCE_SETTLEMENT_CONFIG: 'VIEW_FINANCE_SETTLEMENT_CONFIG',
  ADD_FINANCE_SETTLEMENT_CONFIG: 'ADD_FINANCE_SETTLEMENT_CONFIG',
  EDIT_FINANCE_SETTLEMENT_CONFIG: 'EDIT_FINANCE_SETTLEMENT_CONFIG',
  VIEW_MERCHANT_SETTLEMENT_CONFIG: 'VIEW_MERCHANT_SETTLEMENT_CONFIG',
  ADD_MERCHANT_SETTLEMENT_CONFIG: 'ADD_MERCHANT_SETTLEMENT_CONFIG',
  EDIT_MERCHANT_SETTLEMENT_CONFIG: 'EDIT_MERCHANT_SETTLEMENT_CONFIG',
  EDIT_RATE_FINANCE_SETTLEMENT_CONFIG: 'EDIT_RATE_FINANCE_SETTLEMENT_CONFIG',
  EDIT_PAYMENT_CHANNEL_FINANCE_SETTLEMENT_CONFIG: 'EDIT_PAYMENT_CHANNEL_FINANCE_SETTLEMENT_CONFIG',
  EDIT_PAYMENT_CHANNEL_MERCHANT_SETTLEMENT_CONFIG:
    'EDIT_PAYMENT_CHANNEL_MERCHANT_SETTLEMENT_CONFIG',
  VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_RECONCILIATION:
    'VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_RECONCILIATION',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOAD_SETTLEMENT_SUMMARY_REPORT',
  VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT:
    'VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT',
  GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT:
    'GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT',
  GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT_V2:
    'GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT_VERSION_TWO',
  APPROVE_CHANGE_REQUEST_RATES_BY_SALES_HEAD_FINANCE_SETTLEMENT:
    'APPROVE_CHANGE_REQUEST_RATES_BY_SALES_HEAD_FINANCE_SETTLEMENT',
  APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_HEAD_FINANCE_SETTLEMENT:
    'APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_HEAD_FINANCE_SETTLEMENT',
  APPROVE_CHANGE_REQUEST_RATES_BY_SALES_HEAD_MERCHANT_SETTLEMENT:
    'APPROVE_CHANGE_REQUEST_RATES_BY_SALES_HEAD_MERCHANT_SETTLEMENT',
  APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_HEAD_MERCHANT_SETTLEMENT:
    'APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_HEAD_MERCHANT_SETTLEMENT',
  VIEW_OPTIONS_SETTLEMENT: 'VIEW_OPTIONS_SETTLEMENT',
  DOWNLOAD_LEAD_TEMPLATE: 'DOWNLOAD_LEAD_TEMPLATE',
  DOWNLOAD_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT:
    'DOWNLOAD_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT',
  FILTER_PCHANNEL_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT:
    'FILTER_PCHANNEL_SUMMARY_FILE_BREAKDOWN_REPORT_SETTLEMENT',
  GENERATE_SETTLEMENT_REPORT: 'GENERATE_SETTLEMENT_REPORT',
  REVIEW_SETTLEMENT_REPORT: 'REVIEW_SETTLEMENT_REPORT',
  ENDORSE_SETTLEMENT_REPORT: 'ENDORSE_SETTLEMENT_REPORT',
  APPROVE_SETTLEMENT_REPORT: 'APPROVE_SETTLEMENT_REPORT',
  VIEW_SETTLEMENT_PAGE_LOGS: 'VIEW_SETTLEMENT_PAGE_LOGS',
  VIEW_SETTLEMENT_PAGE_ACCOUNT_HISTORY: 'VIEW_SETTLEMENT_PAGE_ACCOUNT_HISTORY',
  ADD_MERCHANT_BILLING_CONFIGURATION: 'ADD_MERCHANT_BILLING_CONFIGURATION',
  EDIT_MERCHANT_BILLING_CONFIGURATION: 'EDIT_MERCHANT_BILLING_CONFIGURATION',
  VIEW_SIGNED_PROPOSAL: 'VIEW_SIGNED_PROPOSAL',
  VIEW_SIGNED_PSA: 'VIEW_SIGNED_PSA',
  VIEW_VAT_EXEMPTION: 'VIEW_VAT_EXEMPTION',
  VIEW_WIRED_INSTRUCTION_FORM: 'VIEW_WIRED_INSTRUCTION_FORM',
  VIEW_SECURITIES_AND_EXCHANGE_COMMISSION: 'VIEW_SECURITIES_AND_EXCHANGE_COMMISSION',
  VIEW_ARTICLES_OF_INCORPORATION: 'VIEW_ARTICLES_OF_INCORPORATION',
  VIEW_GENERAL_INFORMATION_SHEET: 'VIEW_GENERAL_INFORMATION_SHEET',
  VIEW_KYB_FILES: 'VIEW_KYB_FILES',

  UPLOAD_EXEMPTION_FILE: 'UPLOAD_EXEMPTION_FILE',
  DOWNLOAD_EXEMPTION_FILE: 'DOWNLOAD_EXEMPTION_FILE',
  REQUEST_KYB_EXEMPTION: 'REQUEST_KYB_EXEMPTION',

  EXPORT_ONBOARDING_DASHBOARD: 'EXPORT_ONBOARDING_DASHBOARD',
  DOWNLOAD_ONBOARDING_DASHBOARD: 'DOWNLOAD_ONBOARDING_DASHBOARD',

  ADD_COMPANY_INFORMATION: 'ADD_COMPANY_INFORMATION',
  EDIT_COMPANY_INFORMATION: 'EDIT_COMPANY_INFORMATION',

  FIND_TRANSACTION_IN_OTHER_PAYMENT_CHANNELS: 'FIND_TRANSACTION_IN_OTHER_PAYMENT_CHANNELS',

  INCLUDE_PREVIOUS_FLOATING_TRANSACTION_SETTLEMENT_REPORT:
    'INCLUDE_PREVIOUS_FLOATING_TRANSACTION_SETTLEMENT_REPORT',

  SET_PARTIAL_ONBOARDING_ALLOWED: 'SET_PARTIAL_ONBOARDING_ALLOWED',
  UPDATE_KYB_STATUS: 'UPDATE_KYB_STATUS',

  UPLOAD_KAISER_CHECK_RESULTS: 'UPLOAD_KAISER_CHECK_RESULTS',
  DOWNLOAD_KAISER_CHECK_RESULTS: 'DOWNLOAD_KAISER_CHECK_RESULTS',

  MIGRATE_MERCHANT_INFORMATION: 'MIGRATE_MERCHANT_INFORMATION',

  ENDORSE_MO_APPLICATION: 'ENDORSE_MO_APPLICATION',
  REJECT_MO_APPLICATION: 'REJECT_MO_APPLICATION',
  REQUEST_APPROVAL_MO_APPLICATION: 'REQUEST_APPROVAL_MO_APPLICATION',
  APPROVE_MO_APPLICATION: 'APPROVE_MO_APPLICATION',

  TRIGGER_IRF_FOR_TEST: 'TRIGGER_IRF_FOR_TEST',

  RESEND_MIS_LINK: 'RESEND_MIS_LINK',

  REVIEW_TEST_ACCESS_EXEMPTIONS: 'REVIEW_TEST_ACCESS_EXEMPTIONS',
  ENDORSE_TEST_ACCESS_EXEMPTIONS: 'ENDORSE_TEST_ACCESS_EXEMPTIONS',
  APPROVE_TEST_ACCESS_EXEMPTIONS: 'APPROVE_TEST_ACCESS_EXEMPTIONS',

  EDIT_PAYMENT_CHANNEL_SUB_MID: 'EDIT_PAYMENT_CHANNEL_SUB_MID',

  PROCEED_WITH_CONFIGURATION_INTEGRATION_FORM: 'PROCEED_WITH_CONFIGURATION_INTEGRATION_FORM',
  REJECT_INTEGRATION_FORM: 'REJECT_INTEGRATION_FORM',

  GENERATE_TEST_CREDENTIALS_MERCHANT_PROFILE: 'GENERATE_TEST_CREDENTIALS_MERCHANT_PROFILE',
  GENERATE_PROD_CREDENTIALS_MERCHANT_PROFILE: 'GENERATE_PROD_CREDENTIALS_MERCHANT_PROFILE',

  RELEASE_TOS_CREDENTIALS: 'RELEASE_TOS_CREDENTIALS',

  REJECT_CONFIGURATION_INTEGRATION_FORM: 'REJECT_CONFIGURATION_INTEGRATION_FORM',
  APPROVE_CONFIGURATION_INTEGRATION_FORM: 'APPROVE_CONFIGURATION_INTEGRATION_FORM',
  ASSIGN_INTEGRATION_FORM: 'ASSIGN_INTEGRATION_FORM',

  VIEW_IRF_PROOF_OF_TESTING: 'VIEW_IRF_PROOF_OF_TESTING',
  CONFIGURE_MERCHANT_CERTIFICATE: 'CONFIGURE_MERCHANT_CERTIFICATE',

  ADD_INTEGRATION_MANAGEMENT: 'ADD_INTEGRATION_MANAGEMENT',
  GENERATE_SECRET_KEY_INTEGRATION_MANAGEMENT: 'GENERATE_SECRET_KEY_INTEGRATION_MANAGEMENT',
  GENERATE_CREDENTIALS: 'GENERATE_CREDENTIALS',

  // Reconciliation

  RECONCILIATION_SETTINGS_VIEW: 'RECONCILIATION_SETTINGS_VIEW',

  RECONCILIATION_MID_SETTINGS_CREATE: 'RECONCILIATION_MID_SETTINGS_CREATE',
  RECONCILIATION_MID_SETTINGS_VIEW: 'RECONCILIATION_MID_SETTINGS_VIEW',
  RECONCILIATION_MID_SETTINGS_UPDATE: 'RECONCILIATION_MID_SETTINGS_UPDATE',

  // Remittance

  ADD_REMITTANCE: 'ADD_REMITTANCE',
  EDIT_REMITTANCE: 'EDIT_REMITTANCE',
  DELETE_REMITTANCE: 'DELETE_REMITTANCE',
  GENERATE_SETTLEMENT_AMOUNTS_REMITTANCE: 'GENERATE_SETTLEMENT_AMOUNTS_REMITTANCE',
  VIEW_REMITTANCE: 'VIEW_REMITTANCE',
  VIEW_REMITTANCE_LOGS: 'VIEW_REMITTANCE_LOGS',

  VIEW_ALL_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'VIEW_ALL_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  GENERATE_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'GENERATE_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  REQUEST_FOR_APPROVAL_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'REQUEST_FOR_APPROVAL_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  APPROVE_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'APPROVE_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  REJECT_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'REJECT_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE:
    'DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SETTLEMENT_PAGE',
  GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_REMITTANCE:
    'GENERATE_SUMMARY_FILE_BREAKDOWN_REPORT_REMITTANCE',
  VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_REMITTANCE:
    'VIEW_ALL_GENERATED_SUMMARY_FILE_BREAKDOWN_REPORT_REMITTANCE',
  VIEW_MENU_SUMMARY_REPORT_REMITTANCE: 'VIEW_MENU_SUMMARY_REPORT_REMITTANCE',
  VIEW_MENU_REMITTANCE_RECONCILIATION_REPORT: 'VIEW_MENU_REMITTANCE_RECONCILIATION_REPORT',
  VIEW_ALL_GENERATED_REMITTANCE_RECONCILIATION_REPORT:
    'VIEW_ALL_GENERATED_REMITTANCE_RECONCILIATION_REPORT',
  GENERATE_REMITTANCE_RECONCILIATION_REPORT: 'GENERATE_REMITTANCE_RECONCILIATION_REPORT',
  DOWNLOAD_GENERATED_REMITTANCE_RECONCILIATION_REPORT:
    'DOWNLOAD_GENERATED_REMITTANCE_RECONCILIATION_REPORT',
  DOWNLOAD_GENERATED_SUMMARY_REPORT_REMITTANCE: 'DOWNLOAD_GENERATED_SUMMARY_REPORT_REMITTANCE',
  DELETE_GENERATED_SUMMARY_REPORT_REMITTANCE: 'DELETE_GENERATED_SUMMARY_REPORT_REMITTANCE',
  DOWNLOAD_UPLOADED_FILE_REMITTANCE: 'DOWNLOAD_UPLOADED_FILE_REMITTANCE',
  GENERATE_BREAKDOWN_PAYMENT_CHANNEL_REMITTANCE_REPORT:
    'GENERATE_BREAKDOWN_PAYMENT_CHANNEL_REMITTANCE_REPORT',
  VIEW_ALL_GENERATED_BREAKDOWN_PAYMENT_CHANNEL_REMITTANCE_REPORT:
    'VIEW_ALL_GENERATED_BREAKDOWN_PAYMENT_CHANNEL_REMITTANCE_REPORT',
  VIEW_MENU_REMITTANCE_BREAKDOWN_REPORT_REMITTANCE:
    'VIEW_MENU_REMITTANCE_BREAKDOWN_REPORT_REMITTANCE',
  DOWNLOAD_REMITTANCE_BREAKDOWN_REPORT_REMITTANCE:
    'DOWNLOAD_REMITTANCE_BREAKDOWN_REPORT_REMITTANCE',

  // START: Settlement Version 2
  VIEW_MERCHANT_SETTLEMENT_REPORT: 'VIEW_MERCHANT_SETTLEMENT_REPORT',
  CREATE_MERCHANT_SETTLEMENT_REPORT: 'CREATE_MERCHANT_SETTLEMENT_REPORT',
  ENDORSE_MERCHANT_SETTLEMENT_REPORT: 'ENDORSE_MERCHANT_SETTLEMENT_REPORT',
  APPROVE_MERCHANT_SETTLEMENT_REPORT: 'APPROVE_MERCHANT_SETTLEMENT_REPORT',
  REJECT_MERCHANT_SETTLEMENT_REPORT: 'REJECT_MERCHANT_SETTLEMENT_REPORT',
  BATCH_ENDORSE_MERCHANT_SETTLEMENT_REPORT: 'BATCH_ENDORSE_MERCHANT_SETTLEMENT_REPORT',
  BATCH_APPROVE_MERCHANT_SETTLEMENT_REPORT: 'BATCH_APPROVE_MERCHANT_SETTLEMENT_REPORT',
  BATCH_REJECT_MERCHANT_SETTLEMENT_REPORT: 'BATCH_REJECT_MERCHANT_SETTLEMENT_REPORT',
  DOWNLOAD_MERCHANT_SETTLEMENT_REPORT: 'DOWNLOAD_MERCHANT_SETTLEMENT_REPORT',
  SEND_SETTLEMENT_VALIDATION_REPORT: 'SEND_SETTLEMENT_VALIDATION_REPORT',

  VIEW_CONSOLIDATED_SETTLEMENT_REPORT: 'VIEW_CONSOLIDATED_SETTLEMENT_REPORT',
  CREATE_CONSOLIDATED_SETTLEMENT_REPORT: 'CREATE_CONSOLIDATED_SETTLEMENT_REPORT',
  DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT: 'DOWNLOAD_CONSOLIDATED_SETTLEMENT_REPORT',

  VIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'VIEW_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  CREATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'CREATE_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  ENDORSE_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'ENDORSE_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'APPROVE_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'REJECT_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT: 'DOWNLOAD_MERCHANT_SETTLEMENT_SUMMARY_REPORT',
  // END: Settlement Version 2

  CREATE_TRANSACTION_REQUEST: 'CREATE_TRANSACTION_REQUEST',
  APPROVE_TRANSACTION_REQUEST: 'APPROVE_TRANSACTION_REQUEST',
  REJECT_TRANSACTION_REQUEST: 'REJECT_TRANSACTION_REQUEST',
  CANCEL_TRANSACTION_REQUEST: 'CANCEL_TRANSACTION_REQUEST',

  CATEGORIZE_FLOATING_TRANSACTION: 'CATEGORIZE_FLOATING_TRANSACTION',
  TAG_RECONCILED_TRANSACTION: 'TAG_RECONCILED_TRANSACTION',
  TAG_UNRECONCILED_TRANSACTION_AS_ENDORSED: 'TAG_UNRECONCILED_TRANSACTION_AS_ENDORSED',
  APPROVED_RECONCILED_DATE: 'APPROVED_RECONCILED_DATE',
  NOTIFY_REVIEWED_TRANSACTIONS: 'NOTIFY_REVIEWED_TRANSACTIONS',
  VIEW_RECONCILIATION_SUMMARY_FILES: 'VIEW_RECONCILIATION_SUMMARY_FILES',
  GENERATE_RECONCILIATION_SUMMARY_REPORT: 'GENERATE_RECONCILIATION_SUMMARY_REPORT',
  DOWNLOAD_RECONCILIATION_SUMMARY_REPORT: 'DOWNLOAD_RECONCILIATION_SUMMARY_REPORT',
  VIEW_TEMPLATE_NAME: 'VIEW_TEMPLATE_NAME',
  CHECK_FILTERED_TRANSACTIONS: 'CHECK_FILTERED_TRANSACTIONS',
  TAG_FILTERED_TRANSACTIONS_AS_OFFSET: 'TAG_FILTERED_TRANSACTIONS_AS_OFFSET',
  VIEW_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_DETAILS:
    'VIEW_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_DETAILS',
  REUPLOAD_FINANCE_BANK: 'REUPLOAD_FINANCE_BANK',
  UPDATE_RECONCILIATION_TRANSACTION_REMITTANCE_STATUS:
    'UPDATE_RECONCILIATION_TRANSACTION_REMITTANCE_STATUS',
  UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS: "UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS",

  //Company Profile || Merchant Profile V2
  VIEW_ALL_MERCHANT_PROFILE_VERSION_TWO: 'VIEW_ALL_MERCHANT_PROFILE_VERSION_TWO',
  VIEW_OWN_MERCHANT_PROFILE: 'VIEW_OWN_MERCHANT_PROFILE',
  ADD_MERCHANT_PROFILE_VERSION_TWO: 'ADD_MERCHANT_PROFILE_VERSION_TWO',
  EDIT_MERCHANT_PROFILE_VERSION_TWO: 'EDIT_MERCHANT_PROFILE_VERSION_TWO',
  DELETE_MERCHANT_PROFILE_VERSION_TWO: 'DELETE_MERCHANT_PROFILE_VERSION_TWO',
  GENERATE_TEST_CREDENTIALS_MERCHANT_PROFILE_VERSION_TWO:
    'GENERATE_TEST_CREDENTIALS_MERCHANT_PROFILE_VERSION_TWO',
  GENERATE_PROD_CREDENTIALS_MERCHANT_PROFILE_VERSION_TWO:
    'GENERATE_PROD_CREDENTIALS_MERCHANT_PROFILE_VERSION_TWO',
  CONFIGURE_MERCHANT_CERTIFICATE_VERSION_TWO: 'CONFIGURE_MERCHANT_CERTIFICATE_VERSION_TWO',
  VIEW_ALL_MERCHANT_CERTIFICATES_VERSION_TWO: 'VIEW_ALL_MERCHANT_CERTIFICATES_VERSION_TWO',
  VIEW_MERCHANT_DETAILS_VERSION_TWO: 'VIEW_MERCHANT_DETAILS_VERSION_TWO',
  CONFIGURE_MERCHANT_ID_PAYMENT_CHANNEL: 'CONFIGURE_MERCHANT_ID_PAYMENT_CHANNEL_VERSION_TWO',
  VIEW_MERCHANT_ID_ALL_CONFIGURED_PAYMENT_CHANNELS_VERSION_TWO:
    'VIEW_MERCHANT_ID_ALL_CONFIGURED_PAYMENT_CHANNELS_VERSION_TWO',
  VIEW_MERCHANT_ID_DETAILS_VERSION_TWO: 'VIEW_MERCHANT_ID_DETAILS_VERSION_TWO',
  VIEW_ALL_MERCHANT_CREDENTIALS_VERSION_TWO: 'VIEW_ALL_MERCHANT_CREDENTIALS_VERSION_TWO',
  VIEW_MERCHANT_ID_USER_MANAGEMENT_VERSION_TWO: 'VIEW_MERCHANT_ID_USER_MANAGEMENT_VERSION_TWO',
  RELEASE_MERCHANT_ID_CREDENTIALS_VERSION_TWO: 'RELEASE_MERCHANT_ID_CREDENTIALS_VERSION_TWO',
  VIEW_MERCHANT_ID_CREDENTIALS_VERSION_TWO: 'VIEW_MERCHANT_ID_CREDENTIALS_VERSION_TWO',
  //VIEW_MERCHANT_DETAILS_VERSION_TWO: 'VIEW_MERCHANT_DETAILS_VERSION_TWO',

  // START: Unmatched Transactions Managmeent
  VIEW_UNMATCHED_TRANSACTIONS: 'VIEW_UNMATCHED_TRANSACTIONS',
  VIEW_UPLOADED_FILE: 'VIEW_UPLOADED_FILE',
  ENDORSE_UNMATCHED_TRANSACTION: 'ENDORSE_UNMATCHED_TRANSACTION',
  APPROVE_UNMATCHED_TRANSACTIONS: 'APPROVE_UNMATCHED_TRANSACTIONS',
  REJECT_UNMATCHED_TRANSACTIONS: 'REJECT_UNMATCHED_TRANSACTIONS',
  FILTER_UNMATCHED_TRANSACTIONS: 'FILTER_UNMATCHED_TRANSACTIONS',
  BATCH_ENDORSE_UNMATCHED_TRANSACTIONS: 'BATCH_ENDORSE_UNMATCHED_TRANSACTIONS',
  BATCH_APPROVE_UNMATCHED_TRANSACTIONS: 'BATCH_APPROVE_UNMATCHED_TRANSACTIONS',
  BATCH_REJECT_UNMATCHED_TRANSACTIONS: 'BATCH_REJECT_UNMATCHED_TRANSACTIONS',
  VIEW_APPROVERS_CONFIGURATION: 'VIEW_APPROVERS_CONFIGURATION',
  ADD_APPROVER_DEPARTMENT: 'ADD_APPROVER_DEPARTMENT',
  DELETE_APPROVER_DEPARTMENTS: 'DELETE_APPROVER_DEPARTMENTS',
  EDIT_APPROVER_CONFIGURATIONS: 'EDIT_APPROVER_CONFIGURATIONS',
  UPDATE_UNMATCHED_TRANSACTION: 'UPDATE_UNMATCHED_TRANSACTION',
  VIEW_UNMATCHED_MANAGEMENT_LOGS: 'VIEW_UNMATCHED_MANAGEMENT_LOGS',
  VIEW_UPDATED_TRANSACTIONS: 'VIEW_UPDATED_TRANSACTIONS',
  NOTIFY_MERCHANTS: 'NOTIFY_MERCHANTS',
  // END: Unmatched Transactions Managmeent

  // START: EXCEPTION MONITORING PAGE
  VIEW_EXCEPTION_MONITORING: 'VIEW_EXCEPTION_MONITORING',
  VIEW_EXCEPTION_MONITORING_DETAILS: 'VIEW_EXCEPTION_MONITORING_DETAILS',
  FILTER_EXCEPTION_MONITORING: 'FILTER_EXCEPTION_MONITORING',
  EXCEPTION_MONITORING_DOWNLOAD: 'EXCEPTION_MONITORING_DOWNLOAD'
  // END: EXCEPTION MONITORING PAGE
};

export const DATEFORMATTER = {
  DATE_ONLY: 'date_only',
  YEAR_ONLY: 'year',
  DATE_TIME: 'date_time',
  DAILY: 'daily',
  MONTHLY: 'monthly',
  WEEKLY: 'weekly'
};

export const DATA_TYPE = {
  STRING: 'String',
  URL: 'URL',
  NUMBER: 'Number',
  BOOLEAN: 'Boolean',
  DECIMAL: 'Decimal',
  JSON: 'JSON',
  ARRAY: 'Array',
  NONE: 'None'
};

export const KEYS = {
  MONTHLY_VOLUME_TARGET: 'monthly-volume-target',
  MERCHANT_VISIT_CALL_TARGET: 'merchant-visit-call-target',
  BY_PRODUCT_SERVICES: 'by-product-services',
  ALL_PRODUCT_SERVICES: 'all-product-services',
  SERVICES_PAYGATE_SETUP_FEE: 'services-paygate-setup-fee',
  SERVICES_PAYGATE_TRANSACTIONS: 'services-paygate-transactions',
  SERVICES_PAYBIZ: 'services-paybiz',
  BY_MERCHANTS: 'by-merchants',
  ALL_MERCHANTS: 'all-merchants',
  MERCHANTS_LEADS: 'merchants-leads',
  NEW_MERCHANTS: 'new-merchants',
  SELECTED_MERCHANTS: 'selected-merchants',
  BY_ACCOUNT_OFFICERS: 'by-account-officers',
  ALL_ACCOUNT_OFFICERS: 'all-account-officers',
  ACCOUNT_OFFICERS_GROUPING: 'account-officers-grouping',
  ACCOUNT_OFFICERS_SELECTED_AO: 'account-officers-selected-ao',
  BY_AREAS: 'by-areas',
  AREA_KEY_CITIES: 'areas-key-cities',
  AREA_ALL_CITIES: 'areas-all-cities',
  AREA_ALL_PROVINCES: 'areas-all-provinces',
  AREA_ALL_REGIONS: 'areas-all-regions',
  CUSTOMER_VISIT: 'customer_visit',
  MONTHLY_TARGET: 'monthly_target',
  PROJECTION_STATUS_REPORT: 'projection-status-report',
  AO_PERFORMANCE_REPORT: 'ao-performance-report',
  TIME_SERIES_REPORT: 'time-series-report'
};

export const MONITORING_KEYS = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  MONTH_FORMAT: 'LLLL',
  MONTH_DAY_YEAR_FORMAT: 'yyyy-MM-dd',
  MODULE: 'monitoring',
  KEY_CITY: 'key_city',
  ALL_CITY: 'all_city',
  ALL_PROVINCE: 'all_province',
  ALL_REGION: 'all_region',
  ALL: 'all',
  LEADS: 'leads',
  DATEPICKER: 'DATEPICKER',
  SEGMENTED: 'SEGMENTED',
  DEFAULT: 'DEFAULT'
};

export const APP = {
  ACCOUNTING_OFFICERS: 'ACCOUNTING_OFFICERS',
  MERCHANT: 'MERCHANT',
  MONITORING: 'MONITORING',
  TOOLS: 'TOOLS',
  BILLING_MANAGEMENT: 'BILLING_MANAGEMENT',
  ONBOARDING_DEPARTMENT: 'ONBOARDING_DEPARTMENT',
  TRANSACTIONS: 'TRANSACTIONS',
  AUDIT_LOGS: 'AUDIT_LOGS'
};

export const MODULES = {
  ACCOUNT_OFFICERS: 'AccountOfficers',
  LEADS_MANAGEMENT: 'LeadsManagement',
  TARGET_PROJECTIONS: 'TargetsProjections',
  MERCHANT_PROFILE: 'MerchantProfile',
  DASHBOARD: 'Dashboard',
  MONITORING: 'Monitoring',
  MERCHANT: 'Merchant',
  TOOLS: 'Tools',
  ACCOUNTING_OFFICERS: 'AccountingOfficers',
  PROJECTION_STATUS_REPORT: 'ProjectionStatusReport',
  AO_PERFORMANCE_REPORT: 'AoPerformanceReport',
  TIME_SERIES_REPORT: 'TimeSeriesReport',
  REPORT_TYPE: 'ReportType',
  USER_MANAGEMENT: 'UserManagement',
  ROLE_MANAGEMENT: 'RoleManagement',
  LOOKUPS_MANAGEMENT: 'Lookups',
  INDUSTRIES: 'Industries',
  ADDRESSES: 'Addresses',
  MODULE_MANAGEMENT: 'ModuleManagement',
  PAYMENT_CHANNEL_MANAGEMENT: 'PaymentChannelManagement',
  MERCHANT_LOGS: 'MerchantLogs',
  MERCHANT_PAYMENT_CHANNEL: 'MerchantPaymentChannel',
  NOTIFICATION_SETTINGS: 'NotificationSettings',
  FILE_MANAGEMENT: 'FileManagement',
  MERCHANT_SETTINGS: 'MerchantSettings',
  BILLING_MANAGEMENT: 'BillingManagement',
  RECONCILIATION: 'Reconciliation',
  MONTHLY_RECONCILIATION: 'MonthlyReconciliation',
  RECONCILIATION_VERSION_TWO: 'ReconciliationVersionTwo',
  SETTLEMENT_VERSION_TWO: 'SettlementVersionTwo',
  BILLING: 'Billing',
  UPLOAD_TRANSACTION: 'UploadTransaction',
  SYSTEM_LOGS: 'SystemLogs',
  CASE_MANAGEMENT: 'CaseManagement',
  FINANCE_DASHBOARD: 'Dashboard',
  SYSTEM_SETTINGS: 'SystemSettings',
  BANK_SUMMARY: 'BankSummary',
  SALES_DEPT_DASHBOARD: 'SalesDeptDashboard',
  OTP_MANAGEMENT: 'OtpManagement',
  ONBOARDING_DEPARTMENT: 'OnboardingDepartment',
  ONBOARDING_DASHBOARD: 'OnboardingDashboard',
  TRANSACTIONS: 'Transactions',
  AUDIT_LOGS: 'AuditLogs',
  TRANSACTION_DETAILS: 'TransactionDetails',
  OTC_RECONCILIATION: 'OtcReconciliation',
  RESPONSE_CODES: 'ResponseCodes',
  SECURITY_CODES: 'SecurityCodes',
  MERCHANT_INFORMATION: 'MerchantInformation',
  MERCHANT_STATUS: 'MerchantStatus',
  LEAD_MONITORING: 'LeadMonitoring',
  LEAD_NURTURING: 'LeadNurturing',
  LEAD_SANITATION: 'LeadSanitation',
  MERCHANT_MANAGEMENT: 'MerchantManagement',
  FINANCE_OPERATIONS: 'FinanceOperations',
  MERCHANT_PORTAL: 'MerchantPortal',
  SETTLEMENT_CONFIG: 'SettlementConfig',
  MERCHANT_SETTLEMENT_CONFIG: 'MerchantSettlementConfig',
  MERCHANT_BILLING_CONFIGURATION: 'MerchantBillingConfiguration',
  SETTLEMENT: 'Settlement',
  COMPANY_INFORMATION: 'CompanyInformation',
  PRODUCTIVITY_DASHBOARD: 'ProductivityDashboard',
  TEST_ACCESS_EXEMPTIONS: 'TestAccessExemptions',
  INTEGRATION_FORM_REQUEST: 'IntegrationFormRequest',
  PAYMENT_CHANNEL_REPORTS: 'PaymentChannelReports',
  UNMATCHED_TRANSACTION_MANAGEMENT: 'UnmatchedTransactionManagement',
  EXCEPTION_MONITORING: 'ExceptionMonitoring',
  TOS_PRODUCTIVITY_DASHBOARD: 'TosProductivityDashboard',
  INTEGRATION_MANAGEMENT: 'IntegrationManagement',
  REMITTANCE: 'Remittance',
  MERCHANT_PROFILE_VERSION_TWO: 'MerchantProfileVersionTwo'
};

export const REQUEST = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

export const NOTIFICATION = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  APP: 'APP',
  INTEGRATORS: 'INTEGRATORS',
  EMAIL_PARAMS: 'EMAIL_PARAMS'
};

export const FREQUENCY = {
  MINUTES: 'MINUTES',
  DAYS: 'DAYS',
  MONTHS: 'MONTHS',
  HOURS: 'HOURS'
};

export const MQTT_MODULE = {
  MERCHANT_FILE_MANAGEMENT: 'MERCHANT_FILE_MANAGEMENT',
  ACCOUNT_NOTIFICATION: 'ACCOUNT_NOTIFICATION',
  SYSTEM_LOGS_NOTIFICATION: 'SYSTEM_LOGS_NOTIFICATION',
  REQUIREMENT_FILE_DOWNLOAD: 'REQUIREMENT_FILE_DOWNLOAD',
  PARSING_FILE_NOTIFIER: 'PARSING_FILE_NOTIFIER',
  PARSING_FILE_NOTIFIER_REMITTANCE: 'PARSING_FILE_NOTIFIER_REMITTANCE',
  PARSE_RECONCILE_FILE: 'PARSE_RECONCILE_FILE',
  GENERATE_RECON_REPORT: 'GENERATE_RECON_REPORT',
  GENERATE_MATCHED_TRX: 'GENERATE_MATCHED_TRX',
  CHECK_UNMATCHED_TRANSACTIONS: 'CHECK_UNMATCHED_TRANSACTIONS',
  DOWNLOAD_UNMATCHED_TRANSACTIONS: 'DOWNLOAD_UNMATCHED_TRANSACTIONS',
  GENERATED_DOWNLOAD_UNMATCHED_TRANSACTIONS: 'GENERATED_DOWNLOAD_UNMATCHED_TRANSACTIONS',
  GENERATE_DOWNLOAD_RECONCILED_REPORT: 'GENERATE_DOWNLOAD_RECONCILED_REPORT',
  GENERATE_MONTHLY_RECONCILED_REPORT: 'GENERATE_MONTHLY_RECONCILED_REPORT',
  SYSTEM_APP_NOTIFICATION: 'SYSTEM_APP_NOTIFICATION',
  PARSING_BANK_UPLOAD_FILE_NOTIFIER: 'PARSING_BANK_UPLOAD_FILE_NOTIFIER',
  SEND_CASE_DISCUSSION: 'SEND_CASE_DISCUSSION',
  LIKE_CASE_DISCUSSION: 'LIKE_CASE_DISCUSSION',
  TYPING_DISCUSSION: 'TYPING_DISCUSSION',
  DOWNLOAD_TRX: 'DOWNLOAD_TRX',
  LIKE_LEAD_DISCUSSION: 'LIKE_LEAD_DISCUSSION',
  SEND_LEAD_DISCUSSION: 'SEND_LEAD_DISCUSSION',
  PARSING_LEAD_FILE_NOTIFIER: 'PARSING_LEAD_FILE_NOTIFIER',
  GENERATE_REPORT_STATUS: 'GENERATE_REPORT_STATUS',
  GENERATE_SRF_TRANSACTION_REPORT: 'GENERATE_SRF_TRANSACTION_REPORT',
  RECONCILE_TRX_PROCESS: 'RECONCILE_TRX_PROCESS',
  REMITTANCE_TRX_PROCESS: 'REMITTANCE_TRX_PROCESS'
};
export const MQTT_TYPE = {
  LEAD_MERCHANT_STATUS: 'LEAD_MERCHANT_STATUS'
};

export const MERCHANT_CONFIG = {
  FEES: 'FEES',
  CREDENTIALS: 'CREDENTIALS'
};

export const VALIDATION_TYPE = [
  {
    label: 'Pre Validation',
    code: 'PRE',
    description: 'Validation requirement before status changed.'
  },
  {
    label: 'Post Validation',
    code: 'POST',
    description: 'Validation requirement of the current status.'
  }
];

export const OPTIONS = {
  FINANCE_BANK_DEFAULT_OPTION: [
    {
      id: 'unidentified',
      label: 'Unremitted'
    }
  ],
  TRANSACTION_FIELDS: [
    {
      value: 'amount',
      label: 'Amount',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    },

    {
      value: 'gateway_id',
      label: 'Gateway ID',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    },
    {
      value: 'merchant_id',
      label: 'Merchant ID',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    },
    {
      value: 'request_id',
      label: 'Request ID',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    },
    {
      value: 'trx_date',
      label: 'Transaction Date',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    },
    {
      value: 'response_id',
      label: 'Response ID',
      children: [
        {
          value: 1,
          label: 'Ascending Order'
        },
        {
          value: -1,
          label: 'Descending Order'
        }
      ]
    }
  ]
};

export const BILLING_TYPE = {
  GENERATE_BILLING: 'GENERATE_BILLING',
  ANNUAL_FEE: 'ANNUAL_FEE',
  ONE_TIME_SETUP_FEE: 'ONE_TIME_SETUP_FEE'
};

export const APP_NOTIFS = {
  GENERATE_UNRECONCILED_REPORT: 'GENERATE_UNRECONCILED_REPORT',
  GENERATE_RECONCILED_REPORT: 'GENERATE_RECONCILED_REPORT',
  GENERATE_MONTH_RECONCILED_REPORT: 'GENERATE_MONTH_RECONCILED_REPORT',
  GENERATE_RECON_REPORT: 'GENERATE_RECON_REPORT',
  GENERATE_MATCHED_TRANSACTIONS: 'GENERATE_MATCHED_TRANSACTIONS',
  CHECK_UNMATCHED_TRANSACTIONS: 'CHECK_UNMATCHED_TRANSACTIONS',
  FETCH_RECON_UPLOADED_FILES: 'FETCH_RECON_UPLOADED_FILES',
  SEND_DISCUSSION_NOTIFICATION: 'SEND_DISCUSSION_NOTIFICATION',
  UPDATE_CASE_INFORMATION: 'UPDATE_CASE_INFORMATION',
  INVITE_MEMBER_IN_CASE: 'INVITE_MEMBER_IN_CASE',
  ADD_NEW_USER: 'ADD_NEW_USER',
  INVITE_NEW_USER: 'INVITE_NEW_USER',
  EDIT_USER_DATA: 'EDIT_USER_DATA',
  UPLOADED_LEADS_NOTIFICATION: 'UPLOADED_LEADS_NOTIFICATION',
  GENERATE_REPORT: 'GENERATE_REPORT',
  APPROVE_KYB_EXEMPTION_CREDENTIAL_REQUEST: 'APPROVE_KYB_EXEMPTION_CREDENTIAL_REQUEST',
  SALES_REQUEST_TEST_CREDENTIALS: 'SALES_REQUEST_TEST_CREDENTIALS',
  REJECT_MO_APPLICATION: 'REJECT_MO_APPLICATION',
  APPROVE_MO_APPLICATION: 'APPROVE_MO_APPLICATION',
  REJECT_EXEMPTION_REQUEST: 'REJECT_EXEMPTION_REQUEST',
  APPROVE_EXEMPTION_REQUEST: 'APPROVE_EXEMPTION_REQUEST',
  EXEMPTION_MO_APPROVAL: 'EXEMPTION_MO_APPROVAL',
  RELEASE_TOS_CREDENTIALS: 'RELEASE_TOS_CREDENTIALS',
  RELEASE_TOS_CONFIGURATION: 'RELEASE_TOS_CONFIGURATION',
  TOS_SUBMIT_APPROVAL_CONFIGURATION: 'TOS_SUBMIT_APPROVAL_CONFIGURATION',
  RELEASE_STATUS_CONFIGURATION: 'RELEASE_STATUS_CONFIGURATION',
  ACCOUNT_MANUAL_UNLOCK: 'ACCOUNT_MANUAL_UNLOCK'
};

export const SYSTEM_SETTINGS = {
  DECRYPTION_CREDENTIALS: 'DECRYPTION_CREDENTIALS',
  MERCHANT_FIELDS: 'MERCHANT_FIELDS',
  OTP_SERVICE_CONFIG: 'OTP_SERVICE_CONFIG'
};

export const EDITOR_TOOLBAR = {
  toolbar: [
    [{ header: [1, 2, 3] }],
    [{ font: [] }],
    ['bold', 'italic', 'underline'],
    ['link'],
    [{ color: [] }],
    ['code-block'],
    [
      {
        list: 'ordered'
      },
      {
        list: 'bullet'
      }
    ]
  ]
};

export const DAY_LIST = [
  { label: 'Sunday', code: 'SUNDAY' },
  { label: 'Monday', code: 'MONDAY' },
  { label: 'Tuesday', code: 'TUESDAY' },
  { label: 'Wednesday', code: 'WEDNESDAY' },
  { label: 'Thursday', code: 'THURSDAY' },
  { label: 'Friday', code: 'FRIDAY' },
  { label: 'Saturday', code: 'SATURDAY' }
];

export const MERCHANT_STATUS = {
  LEAD_NURTURING: 'LEAD NURTURING',
  LEAD_LOST: 'LEAD LOST',
  LEAD_CONVERTED: 'LEAD CONVERTED',
  LEAD_INVALID: 'LEAD INVALID',
  LEAD_SANITATION: 'LEAD SANITATION',
  FINANCE_INVOICE_SENT_TO_MERCHANT: 'FINANCE INVOICE SENT TO MERCHANT',
  CONFIRMED_PROOF_OF_INITIAL_PAYMENT: 'CONFIRMED PROOF OF INITIAL PAYMENT',
  PENDING_FINANCE_INVOICE: 'PENDING FINANCE INVOICE',
  PENDING_COMMERCIAL_DOCUMENTS: 'PENDING COMMERCIAL DOCUMENTS',
  MERCHANT_PROFILE_GENERATED: 'MERCHANT PROFILE GENERATED',
  PENDING_MOC_COMPLETION: 'PENDING MOC COMPLETION',
  PENDING_MIS_COMPLETION: 'PENDING MIS COMPLETION',
  MERCHANT_KYB_PASSED_OR_FAILED: 'MERCHANT KYB PASSED/FAILED',
  STAGING_CREDENTIALS: 'STAGING_CREDENTIALS',
  STAGING_CREDENTIALS_ONGOING_CREATION: 'STAGING CREDENTIALS - ONGOING CREATION',
  STAGING_CREDENTIALS_TOS_CONFIGURATION: 'STAGING CREDENTIALS - TOS CONFIGURATION',
  STAGING_CREDENTIALS_FRAUD_CONFIGURATION: 'STAGING CREDENTIALS - FRAUD CONFIGURATION',
  STAGING_CREDENTIALS_SENT_TO_MERCHANT: 'STAGING CREDENTIALS - SENT TO MERCHANT',
  STAGING_ONGOING_INTEGRATION: 'STAGING - ONGOING INTEGRATION',
  PRODUCTION_CREDENTIALS_ONGOING_CREATION: 'PRODUCTION CREDENTIALS - ONGOING CREATION',
  PRODUCTION_CREDENTIALS_TOS_CONFIGURATION: 'PRODUCTION CREDENTIALS - TOS CONFIGURATION',
  PRODUCTION_CREDENTIALS_FRAUD_CONFIGURATION: 'PRODUCTION CREDENTIALS - FRAUD CONFIGURATION',
  WAITING_FOR_MERCHANT_GO_LIVE: 'WAITING FOR MERCHANT GO LIVE',
  MERCHANT_IS_LIVE: 'MERCHANT IS LIVE',
  PRODUCTION_CREDENTIALS: 'PRODUCTION_CREDENTIALS',
  FOR_MERCHANT_ONBOARDING_DUE_DILIGENCE: 'FOR MERCHANT ONBOARDING DUE DILIGENCE',
  FOR_IRF: 'FOR IRF'
};

export const MERCHANT_STATUS_CODES = {
  MERCHANT_KYB_PASSED_OR_FAILED: 'merchant_kyb_passed_failed'
};

export const KYB_STATUS = {
  WITH_CONDITIONAL_APPROVAL: 'WITH_CONDITIONAL_APPROVAL',
  WITH_COMPLETE_DOCUMENTS: 'WITH_COMPLETE_DOCUMENTS',
  WITH_PENDING_DOCUMENTS: 'WITH_PENDING_DOCUMENTS'
};

export const MERCHANT_FORMS = {
  MIS_FORM: 'Merchant Information Sheet',
  MOC_FORM: 'Merchant Onboarding Credentials',
  VAT_EXEMPTION: 'Vat Exemption'
};

export const MOC_TYPE = {
  SEC: 'SEC',
  AOI: 'AOI',
  GIS: 'GIS'
};

export const MERCHANT_FORM_STAGES = {
  1: MERCHANT_STATUS.PENDING_MIS_COMPLETION,
  2: MERCHANT_STATUS.PENDING_COMMERCIAL_DOCUMENTS,
  3: MERCHANT_STATUS.PENDING_FINANCE_INVOICE,
  4: MERCHANT_STATUS.FINANCE_INVOICE_SENT_TO_MERCHANT,
  5: MERCHANT_STATUS.CONFIRMED_PROOF_OF_INITIAL_PAYMENT,
  6: MERCHANT_STATUS.PENDING_MOC_COMPLETION,
  7: MERCHANT_STATUS.MERCHANT_PROFILE_GENERATED,
  8: MERCHANT_STATUS.FOR_MERCHANT_ONBOARDING_DUE_DILIGENCE,
  9: MERCHANT_STATUS.FOR_IRF,
  10: MERCHANT_STATUS.STAGING_CREDENTIALS,
  11: MERCHANT_STATUS.PRODUCTION_CREDENTIALS
};

export const INVOICE_APPROVAL_STATUS = {
  REJECTED: 'REJECTED'
};

export const VAT_RECLASSIFICATION_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed'
};

export const LEAD_LOG_ACTIONS = {
  CREATE_ACTIVITY: 'CREATE ACTIVITY',
  EDIT_ACTIVITY: 'EDIT ACTIVITY',
  UPDATE_LEAD: 'UPDATE LEAD'
};

export const OTP_PARAMETER_PATTERNS = {
  OTP: '##OTP##'
};

export const OTP_PURPOSE = {
  DEFAULT: 'DEFAULT'
};

export const COMPANY_INFORMATION_FIELD_NAMES = {
  legal_entity_name: 'Legal Entity',
  trade_name: 'DBA / Trade Name',
  registered_address: 'Registered Address',
  country_id: 'Country',
  city: 'City',
  ownership_id: 'Ownership',
  business_type_id: 'Business Type',
  business_size_id: 'Business Size',
  monthly_rental_id: 'Monthly Rental',
  num_of_employees_id: 'Number of Employees',
  floor_area: 'Floor Area/Sqm',
  company_website: 'Company Website',
  industry_id: 'Industry',
  average_transaction_amount: 'Average Transaction',
  average_transaction_count: 'Amount Average Transaction',
  potential_monthly_volume: 'Count Potential Monthly',
  required_currency_id: 'Volume Required Currency',
  offerings: 'Products Sold/Services Offered',
  company_reg_num: 'Company Registration Number',
  years_in_operation: 'Years in Operation',
  tin: 'Tax Identification (TIN)',
  tax_exemption_id: 'Tax Exemption',
  owner_information: 'Owner Information',
  authorized_signatory: 'Authorized Signatory'
};

export const SETTLEMENT_INFORMATION_FIELD_NAMES = {
  account_name: 'Account Name',
  account_number: 'Account Number',
  bank_name: 'Bank Name',
  bank_branch: 'Bank Branch',
  bank_account_currency_id: 'Bank Account',
  swift_code: 'Currency Swift Code',
  bank_routing_number: 'Bank Routing Number',
  splitpay: 'Split Pay',
  billing_method_id: 'Billing Method'
};

export const TRADE_REFERENCE_FIELD_NAMES = {
  customer_supplier: 'Customer Supplier',
  contact_person: 'Contact Person',
  contact_number: 'Contact Number',
  trade_email: 'Email Address',
  trade_referred_by_id: 'Referred By',
  trade_rm: 'RM Name'
};

export const CONTACT_INFORMATION_FIELD_NAMES = {
  landline_1: 'Landline 1',
  landline_2: 'Landline 2',
  email: 'Email Address',
  mobile_num: 'Contact Number',
  contact_landline_1: 'Contact Information - Landline 1',
  contact_landline_2: 'Contact Information - Landine 2',
  contact_email: 'Contact Information - Email Address',
  contact_mobile_num: 'Contact Information - Contact Number'
};

export const PRIMARY_CONTACT_FIELD_NAMES = {
  full_name: 'Full Name',
  designation: 'Designation',
  email: 'Email Address',
  mobile_num: 'Mobile Number',
  primary_full_name: 'Primary Contact - Full Name',
  primary_designation: 'Primary Contact - Designation',
  primary_email: 'Primary Contact - Email Address',
  primary_mobile_num: 'Primary Contact - Contact Number'
};

export const FINANCE_CONTACT_FIELD_NAMES = {
  full_name: 'Full Name',
  designation: 'Designation',
  email: 'Email Adress',
  mobile_num: 'Mobile Number',
  fin_mobile_num: 'Mobile Number',
  finance_full_name: 'Finance Contact - Full Name',
  finance_designation: 'Finance Contact - Designation',
  finance_email: 'Finance Contact - Email Address',
  finance_mobile_num: 'Finance Contact - Mobile Number'
};

export const AUTHORIZED_SIGNATORY_FIELD_NAMES = {
  full_name: 'Full Name',
  mobile_num: 'Mobile Number',
  birth_date: 'Birth Date',
  citizenship: 'Citizenship',
  designation: 'Designation',
  email: 'Email Address'
};
export const OWNER_INFORMATION_FIELD_NAMES = {
  full_name: 'Full Name',
  address: 'Address',
  mobile_num: 'Mobile Number',
  birth_date: 'Birth Date',
  designation: 'Designation',
  landline: 'Landline',
  email: 'Email Address'
};
export const KYB_FIELD_NAMES = {
  sec_files: 'SEC FILE',
  aoi_files: 'AOI FILE',
  gis_files: 'GIS FILE'
};

export const SETTLEMENT_REPORT_TYPES = {
  MDSR: 'MDSR',
  MWSR: 'MWSR'
};

export const MERCHANT_SETTINGS_ENVIRONMENT = {
  TEST: 'TEST',
  PROD: 'PROD'
};

export const ONBOARDING_ENVIRONMENT_TYPES = {
  PROD: 'prod',
  TEST: 'test'
};

export const IRF_STATUS = {
  PENDING: 'pending',
  IN_CONFIGURATION: 'in_configuration',
  FOR_APPROVAL: 'for_approval',
  REJECTED: 'rejected',
  REJECTED_FINAL: 'rejected_final',
  APPROVED: 'approved'
};

export const FIELD_TYPES = ['text_box', 'dropdown'];

export const DATA_TYPES = [
  'string',
  'url',
  'number',
  'boolean',
  'amount',
  'decimal',
  'json',
  'array',
  'none'
];

export const PREDEFINED_PAYLOAD_CODES = ['tier'];

export const S3_KEY = {
  PROD_PROOF_TESTING: 'irf_prod_proof_testing'
};
export const ROLE_CODES = {
  TECHNICAL_ONBOARDING_SPECIALIST: 'TECHNICAL_ONBOARDING_SPECIALIST'
};

//Title label for file description
export const MOC_BUSINESS_TYPE_DESCRIPTION = {
  OFFICIAL_GAZETTE_FILE: 'State University Charter Proof',
  DTI_COR: 'Department of Trade and Industry Certificate of Registration',
  COR_BIR_FORM_2303: 'Certificate of Registration of Bureau of Internal Revenue Form 2303',
  GOVT_ISSUED_VALID_ID: 'Government Issued Valid ID',
  SECURITY_AND_EXCHANGE_COMMISSION: 'Security and Exchange Commission',
  ARTICLES_OF_INCORPORATION: 'Article of Incorporation',
  GENERAL_INFORMATION_SHEET: 'General Information Sheet',
  SECRETARY_CERTIFICATE: 'Secretary Certificate',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO_WITH_20_AND_ABOVE_OWNERSHIP:
    'Government Issued Valid Id of Corporate Secretary and Ultimate Beneficiary Owner with 20% and Above Ownership',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO:
    'Government Issued Valid of Corporate Secretary and Ultimate Beneficiary Owner',
  CITY_COUNCIL_OR_PROVINCIAL_BOARD_RESOLUTION_AUTHORIZING_THE_ENGAGEMENT:
    'City Council or Provincial Board Resolution Authorizing the engagement',
  DILG_SEAL_OF_GOOD_HOUSEKEEPING: 'DILG Certificate of Seal of Good House Keeping',
  LGU_SEAL_OF_GOOD_HOUSEKEEPING: 'LGU Certificate of Seal of Good House Keeping',
  CDA_REGISTRATION: 'Cooperatives Development Authority Registration',
  CDA_MEMBERSHIP_PROFILE: 'Cooperatives Development Authority Membership Profile',
  CDA_CERTIFICATE_OF_GOOD_STANDING:
    'Cooperatives Development Authority Certificate of Good Standing',
  COMPANY_HANDBOOK: 'Company Handbook'
};

//Dropdown Label
export const MOC_BUSINESS_TYPE_CATEGORY = {
  OFFICIAL_GAZETTE_FILE: 'Proof of Documentation E.G Presidential Decree or RA File',
  DTI_COR: 'COR',
  COR_BIR_FORM_2303: 'BIR 2303',
  GOVT_ISSUED_VALID_ID: 'Govt Issued ID',
  SECURITY_AND_EXCHANGE_COMMISSION: 'SEC',
  ARTICLES_OF_INCORPORATION: 'AOI',
  GENERAL_INFORMATION_SHEET: 'GIS',
  SECRETARY_CERTIFICATE: 'SC',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO_WITH_20_AND_ABOVE_OWNERSHIP: 'Govt Issued ID',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO: 'Govt Issued ID',
  CITY_COUNCIL_OR_PROVINCIAL_BOARD_RESOLUTION_AUTHORIZING_THE_ENGAGEMENT: 'Official Gazette',
  DILG_SEAL_OF_GOOD_HOUSEKEEPING: 'Seal of Good House Keeping',
  LGU_SEAL_OF_GOOD_HOUSEKEEPING: 'Seal of Good House Keeping',
  CDA_REGISTRATION: 'CDA Registration',
  CDA_MEMBERSHIP_PROFILE: 'CDA Membership Profile',
  CDA_CERTIFICATE_OF_GOOD_STANDING: 'CDA Certificate of Good Standing',
  COMPANY_HANDBOOK: 'Company Handbook'
};

export const MOC_REQUIRED_FILES_DOCUMENT_TYPE = {
  OFFICIAL_GAZETTE_FILE: 'OFFICIAL_GAZETTE_FILE',
  DTI_COR: 'DTI_COR',
  COR_BIR_FORM_2303: 'COR_BIR_FORM_2303',
  GOVT_ISSUED_VALID_ID: 'GOVT_ISSUED_VALID_ID',
  SECURITY_AND_EXCHANGE_COMMISSION: 'SECURITY_AND_EXCHANGE_COMMISSION',
  ARTICLES_OF_INCORPORATION: 'ARTICLES_OF_INCORPORATION',
  GENERAL_INFORMATION_SHEET: 'GENERAL_INFORMATION_SHEET',
  SECRETARY_CERTIFICATE: 'SECRETARY_CERTIFICATE',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO_WITH_20_AND_ABOVE_OWNERSHIP:
    'GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO_WITH_20_AND_ABOVE_OWNERSHIP',
  GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO: 'GOVT_ISSUED_VALID_ID_OF_CORP_SEC_AND_UBO',
  CITY_COUNCIL_OR_PROVINCIAL_BOARD_RESOLUTION_AUTHORIZING_THE_ENGAGEMENT:
    'CITY_COUNCIL_OR_PROVINCIAL_BOARD_RESOLUTION_AUTHORIZING_THE_ENGAGEMENT',
  DILG_SEAL_OF_GOOD_HOUSEKEEPING: 'DILG_SEAL_OF_GOOD_HOUSE_KEEPING',
  LGU_SEAL_OF_GOOD_HOUSEKEEPING: 'LGU_SEAL_OF_GOOD_HOUSE_KEEPING',
  CDA_REGISTRATION: 'CDA_REGISTRATION',
  CDA_MEMBERSHIP_PROFILE: 'CDA_MEMBERSHIP_PROFILE',
  CDA_CERTIFICATE_OF_GOOD_STANDING: 'CDA_CERTIFICATE_OF_GOOD_STANDING',
  COMPANY_HANDBOOK: 'COMPANY_HANDBOOK'
};

export const TENOR_DATA_TYPES = ['string', 'amount'];
export const FLOATING_TRANSACTION_TYPES = [
  {
    label: 'Refund',
    code: 'refund'
  },
  {
    label: 'Offset',
    code: 'offset'
  },
  {
    label: 'Auto-reversal',
    code: 'auto_reversal'
  }
];

export const RECONCILED_TRANSACTION_TAGS = [
  {
    label: 'Manual Reconciled',
    code: 'TAG_AS_MANUAL_RECON'
  },
  {
    label: 'Review',
    code: 'TAG_AS_REVIEW'
  }
];

export const ENVIRONMENT = [
  {
    label: 'Test',
    value: 'TEST'
  },
  {
    label: 'Production',
    value: 'PROD'
  }
];

export const MID_CREDENTIALS = [
  {
    label: 'Merchant Key',
    value: 'merchant_key'
  },
  {
    label: 'Username',
    value: 'username'
  },
  {
    label: 'Password',
    value: 'password'
  }
];
